import { useQuery } from '@tanstack/react-query'
import { Alert, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { TitoloPagina } from '../layout/Pagina'
import { elencaAttivita } from './gestione.api'

const QUANDO = new Intl.DateTimeFormat('it-IT', { dateStyle: 'short', timeStyle: 'short' })

export function LogAttivita() {
  const { data: righe = [], error, isLoading } = useQuery({ queryKey: ['log-attivita'], queryFn: elencaAttivita })
  return (
    <Stack spacing={2.5}>
      <TitoloPagina titolo="Log attività" sottotitolo="Le ultime 200 operazioni sul tuo account. Il registro non si modifica né si cancella." />
      {error && <Alert severity="error">{error.message}</Alert>}
      <Paper variant="outlined">
        <TableContainer>
          <Table size="small" aria-label="Log attività">
            <TableHead>
              <TableRow>
                <TableCell>Quando</TableCell>
                <TableCell>Utente</TableCell>
                <TableCell>Attività</TableCell>
                <TableCell>Dettagli</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {righe.map((r) => (
                <TableRow key={r.id}>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{QUANDO.format(new Date(r.quando))}</TableCell>
                  <TableCell>{r.utente}</TableCell>
                  <TableCell>{r.attivita}</TableCell>
                  <TableCell>{r.dettagli || '—'}</TableCell>
                </TableRow>
              ))}
              {!isLoading && righe.length === 0 && (
                <TableRow><TableCell colSpan={4}><Typography color="text.secondary" sx={{ py: 2 }}>Nessuna attività registrata.</Typography></TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Stack>
  )
}
